export default __webpack_public_path__ + "static/media/alert-icon-9.78208eff.svg";